export default __webpack_public_path__ + "static/media/aboutus.89e1190b.jpg";